export default __webpack_public_path__ + "static/media/complete_Practice.dbc15d8f.svg";